import React, { useContext, useState, useEffect } from 'react';
import {Row, Col} from 'react-bootstrap'
import Login from "../Login/Login";
import Register from "../Login/Register";
import Verify from "../Login/Verify";
import { GlobalContext } from "../../handlers/GlobalContext";
import { useLocation, useHistory } from 'react-router-dom';

const HomeBlogPageHeader = () => {
    const [ state, dispatch] = useContext(GlobalContext);
    const [ actionSelected, setActionSelected] = useState(0);
    const [ initiallyLoaded, setInitiallyLoaded ] = useState(false);
    const search = useLocation().search;
    const history = useHistory();
    const queryParams = new URLSearchParams(search);
    const action = queryParams.get("action");
    const token = queryParams.get("token");

    const selectAction = (act) => {
        setActionSelected(act)
    }

    const resetAction = (removeQuery) => {

        if(!!removeQuery) {
            queryParams.delete('action');
            queryParams.delete('token');
            history.replace({
                search: queryParams.toString(),
            })
        }

        selectAction(0);
    }

    useEffect(() => {
        if(!!initiallyLoaded) return;
        if(!!action && ["0","1","2","3"].indexOf(action) > -1) selectAction(action);

        setInitiallyLoaded(true);
    }, [initiallyLoaded])

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className="blog-home-hero">
            <div className="container">
                <div className="row">
                    <div className="blog-home-hero-content text-center col">
                        <h1>{translate("home-public-title","EAHP Reconstitution & Dilution Database for antibiotics")} </h1>
                        <p>{translate("home-public-subtitle","approved and registered in Serbia, Croatia, Slovenia, Bosnia and Herzegovina, North Macedonia and Montenegro")}</p>
                    </div>
                </div>
                { !state.authenticated && actionSelected == 0 ? (

                    <Row>
                        <Col lg={2}></Col>
                        <Col lg={3}>
                            <div className={"public-action-button"} onClick={() => {selectAction(1)} }>
                                {translate("home-button-login","Login")}
                            </div>
                        </Col>
                        <Col lg={2}></Col>
                        <Col lg={3}>
                            <div className={"public-action-button"} onClick={() => {selectAction(2)}}>
                                {translate("home-button-register","Register")}
                            </div>
                        </Col>
                        {/*<Col lg={1}></Col>*/}
                        {/*<Col lg={2}>*/}
                            {/*<div className={"public-action-button"} onClick={() => {selectAction(3)} }>*/}
                                {/*{translate("home-button-verify","Verify")}*/}
                            {/*</div>*/}
                        {/*</Col>*/}
                        <Col lg={2}></Col>
                    </Row>
                ) : null }

                { !state.authenticated && actionSelected == 1 ? (

                    <Row>
                        <Col lg={4}></Col>
                        <Col lg={4}>
                            <div className="blog-home-hero-content text-center col">
                                <Login reset={resetAction} set={selectAction} token={token}/>
                            </div>
                        </Col>
                        <Col lg={4}></Col>
                    </Row>
                ) : null }

                { !state.authenticated && actionSelected == 2 ? (
                    <Row>
                        <Col lg={2}></Col>
                        <Col lg={8}>
                            <div className="blog-home-hero-content text-center col">
                                <Register reset={resetAction}/>
                            </div>
                        </Col>
                        <Col lg={2}></Col>
                    </Row>
                ) : null }

                { !state.authenticated && actionSelected == 3 ? (
                    <Row>
                        <Col lg={4}></Col>
                        <Col lg={4}>
                            <div className="blog-home-hero-content text-center col">
                                <Verify reset={resetAction} set={selectAction} token={token}/>
                            </div>
                        </Col>
                        <Col lg={4}></Col>
                    </Row>
                ) : null }
            </div>
        </div>
    );
};

export default HomeBlogPageHeader;
